export const hasSameDate = (date1, date2) => {
  if ((!date1 && date2) || (date1 && !date2)) return false;

  if (date1 !== date2) {
    if (date1.toISOString() !== date2) {
      return false;
    }
  }

  return true;
};
